(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.FieldSignalPairOfferCore = api;
})(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';
  const experiment = 'pro-pair-offer-2026-09-17';
  const arm = 'dedicated_offer';
  const offers = {
    single: { price: 12500, pairs: 1, label: '1 Pro pair', protection: 'No added protection plan' },
    duo: { price: 19900, pairs: 2, label: '2 Pro pairs', protection: 'Free 2-year protection for both' },
  };
  const paidProtectionPrice = 3799;
  function selectedPlan(config, option, paidProtectionSelected = false) {
    return option === 'duo' ? config.protection : option === 'single' && paidProtectionSelected ? config.paidProtection : null;
  }
  function validate(config, option, paidProtectionSelected = false) {
    const offer = offers[option];
    const variant = config?.[option];
    if (!offer || config?.currency !== 'USD' || !Number.isSafeInteger(Number(variant?.id)) || Number(variant.id) < 1 || variant.available !== true || Number(variant.price) !== offer.price) {
      throw new Error('This offer is temporarily unavailable. Please refresh and try again.');
    }
    if (option === 'duo' || paidProtectionSelected) {
      const plan = selectedPlan(config, option, paidProtectionSelected);
      const expectedPrice = option === 'duo' ? 0 : paidProtectionPrice;
      if (!Number.isSafeInteger(Number(plan?.id)) || Number(plan.id) < 1 || Number(plan.id) === Number(variant.id) || plan.available !== true || Number(plan.price) !== expectedPrice) {
        throw new Error(`We could not confirm the ${option === 'duo' ? 'included' : 'optional'} 2-year protection. Please refresh and try again.`);
      }
    }
    return offer;
  }
  function total(config, option, paidProtectionSelected = false) {
    return validate(config, option, paidProtectionSelected).price + (option === 'single' && paidProtectionSelected ? paidProtectionPrice : 0);
  }
  function buildItems(config, option, color, reference, attribution = {}, paidProtectionSelected = false) {
    const offer = validate(config, option, paidProtectionSelected);
    if (!['Carbon Black', 'Army Green', 'Desert'].includes(color)) throw new Error('Please select a color.');
    if (!reference) throw new Error('We could not prepare your selection. Please refresh and try again.');
    const properties = {
      ...attribution,
      _fs_experiment: experiment,
      _fs_arm: arm,
      _fs_offer: option,
      _fs_offer_ref: reference,
      Color: color,
      'Complete pairs': String(offer.pairs),
      Protection: option === 'duo' ? '2-year protection for both pairs included' : paidProtectionSelected ? '2-year protection added' : 'No added protection plan',
    };
    // The paid plan can be removed independently in checkout. Its native child
    // line is the source of truth; avoid leaving a stale claim on the hardware.
    if (option === 'single' && paidProtectionSelected) delete properties.Protection;
    const parentId = Number(config[option].id);
    const items = [{ id: parentId, quantity: 1, properties }];
    const plan = selectedPlan(config, option, paidProtectionSelected);
    if (plan) items.push({
      id: Number(plan.id), quantity: 1, parent_id: parentId,
      properties: { _fs_experiment: experiment, _fs_arm: arm, _fs_offer: option, _fs_offer_ref: reference, _fs_parent: reference, 'Covered pairs': String(offer.pairs) },
    });
    return items;
  }
  function validateCart(cart, config, option, reference, paidProtectionSelected = false) {
    const offer = validate(config, option, paidProtectionSelected);
    const owned = (cart.items || []).filter(item => item.properties?._fs_offer_ref === reference);
    const parents = owned.filter(item => Number(item.variant_id) === Number(config[option].id) && !item.parent_relationship);
    if (cart.currency !== 'USD' || parents.length !== 1 || Number(parents[0].quantity) !== 1 || Number(parents[0].original_line_price) !== offer.price || Number(parents[0].final_line_price) > offer.price) {
      throw new Error('Your offer total could not be confirmed. Please review your cart before continuing.');
    }
    const parent = parents[0];
    const children = (cart.items || []).filter(item => {
      const parentKey = item.parent_relationship?.parent_key || item.parent_relationship?.parent?.key;
      return item !== parent && (item.properties?._fs_offer_ref === reference || parentKey === parent.key);
    });
    const plan = selectedPlan(config, option, paidProtectionSelected);
    if (!plan && children.length) throw new Error('Your selection could not be confirmed. Please review your cart.');
    if (plan) {
      const child = children[0];
      const parentKey = child?.parent_relationship?.parent_key || child?.parent_relationship?.parent?.key;
      if (children.length !== 1 || Number(child.variant_id) !== Number(plan.id) || Number(child.quantity) !== 1 || Number(child.final_line_price) !== Number(plan.price) || Number(child.original_line_price) !== Number(plan.price) || parentKey !== parent.key || child.properties?.['Covered pairs'] !== String(offer.pairs)) {
        throw new Error('Your protection plan could not be confirmed. Please review your cart before continuing.');
      }
    }
    return true;
  }
  return { experiment, arm, offers, paidProtectionPrice, validate, total, buildItems, validateCart };
});
